module.exports = __webpack_public_path__ + "img/avatar-square.d4d50da0.svg";